import React, { FC } from 'react';

import {
    Card,
    Line,
} from '@components/1-atoms';

import {
    TextView,
} from '@components/2-molecules';

import * as utils from '@lib/utils';

import { NavigationProp } from '@react-navigation/native';

type Props = {
    data: any;
    navigation: NavigationProp<any>;
};

const Business: FC<Props> = ({ navigation, data }) => {

    const name = data?.name;
    const businessType = data?.businessType?.name;
    const financialYear = `On every ${utils.formatDate(data?.financialDate, "MMMM dd")}`;


    return (
        <Card title='Business'>
            <TextView label={"Name"} defaultValue={name} />
            <Line h={1} />

            <TextView label={"Businees Type"} defaultValue={businessType} />
            <Line h={1} />

            <TextView label={"First day of financial year"} defaultValue={financialYear} />
            <Line h={1} />

            {/* <TextView multiline label={"Business description"} defaultValue={description} />
            <Line h={1} />

            <TextView multiline label={"Default Document footnote"} defaultValue={footerNote} />
            <Line h={1} /> */}
        </Card>
    );
};

export default Business;